// ---------------------------------------------------------------------------------
// Drop down filters
// ---------------------------------------------------------------------------------
// Filter actualized from querystring and customer actions
var actualFilters = [];

// Update actualFilters with querystring
$(function () {
    var uri = getQueryStringAsArray();
    var countKeys = 0;
    for (var key in uri) {
        countKeys++;
    }
    if (countKeys > 0) {
        for (var key in uri) {
            //console.log(uri[key]);
            if (uri[key].indexOf('|')) {
                arguments = uri[key].split('|');
            } else {
                arguments[0] = uri[key];
            }
            actualFilters[key] = [];
            for (var value in arguments) {
                if (actualFilters[key].indexOf(arguments[value]) == -1)
                    actualFilters[key].push(arguments[value]);
                constructFilterItem(key, arguments[value], getOptionText(key, arguments[value]));
                checkOptionSelected(key, arguments[value]);
            }
        }
    }
});


$("[id^='ddtop']").on('click', function () {
    var parts = $(this).attr('id').split('_');
    $(".dropdown dd ul").hide();
    $("#ddlist_" + parts[1]).children('ul').toggle();
    $("#ddlist_" + parts[1]).slideToggle('fast');
});

$(".dropdown dd ul li a").on('click', function () {
    $(".dropdown dd ul").hide();
});

function getSelectedValue(id) {
    return $("#" + id).find("dt a span.value").html();
}

$(document).bind('click', function (e) {
    var $clicked = $(e.target);
    if (!$clicked.parents().hasClass("dropdown")) $(".dropdown dd .multiSelect").hide();
});

$('.mutliSelect input[type="checkbox"]').on('click', function () {
    var filterName = $(this).data('filter');
    if ($(this).prop("checked") == true) {
        if (actualFilters[filterName] == undefined)
            actualFilters[filterName] = [];
        if (actualFilters[filterName].indexOf($(this).val()) == -1)
            actualFilters[filterName].push($(this).val());
    } else {
        idx = actualFilters[filterName].indexOf($(this).val());
        if (idx != -1) {
            actualFilters[filterName].splice(idx, 1);
        }
    }
});




function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
        return uri + separator + key + "=" + value;
    }
}

// Read a page's GET URL variables and return them as an associative array.
function getUrlVars()
{
    var vars = {}, hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        //vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}


function getQueryStringAsArray() {

    var queryStr = window.location.search,
        queryArr = queryStr.replace('?', '').split('&'),
        queryParams = [];

    for (var q = 0, qArrLength = queryArr.length; q < qArrLength; q++) {
        var qArr = queryArr[q].split('=');
        queryParams[qArr[0]] = qArr[1];
    }

    return queryParams;

}

function getParameterByName(name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function redirectSortFilterPage(sort, filter, page, type, libelle) {
    var uri = window.location.href;

    if (sort != null) {
        var valTri = $(sort).val();
        var keySort = 'tri';
        uri = updateQueryStringParameter(uri, keySort, valTri);
    }
    if (filter != null) {
        var valFilter = $(filter).val();
        var keyFilter = $(filter).attr('id');
        uri = updateQueryStringParameter(uri, keyFilter, valFilter);
    }
    if (page != null) {
        var valPage = ($(page).attr('href').split('page=')[1]);
        var key = 'page';
        uri = updateQueryStringParameter(uri, key, valPage);
        if (type == 'recherche')
            uri = updateQueryStringParameter(uri, 'recherche', libelle);
    }


    window.location.href = uri;
}

// TRI FONCTION
function tri(idItem, idCurrent, type)
{
    redirectSortFilterPage(idItem, null, null);
}
$.fn.exists = function () {
    return this.length !== 0;
};


var currentSlug = '';
var currentType = '';


function removeFilter(idFilter) {
    var args = idFilter.split('°°');
    $('#' + idFilter).remove();
    actualFilters[args[0]].splice(actualFilters[args[0]].indexOf(args[1]), 1);
    if (actualFilters[args[0]].length == 0)
        actualFilters.splice(actualFilters.indexOf(args[0]), 1);
    submitFilters();

}

function removeFilters() {
    var params = getQueryStringAsArray();
    if (params['recherche'] !== 'undefined') {
        window.location.href = window.location.href.split('?')[0] + '?recherche=' + params['recherche'];
    } else {
        window.location.href = window.location.href.split('?')[0];
    }
}


function getOptionText(comboId, optionKey) {

    if ($('#' + comboId + '°' + optionKey).exists()) {
        return $('#' + comboId + '°' + optionKey).data("text");
    } else {
        return false;
    }
}

function checkOptionSelected(comboId, optionKey) {
    if ($('#' + comboId + '°' + optionKey).exists()) {
        return $('#' + comboId + '°' + optionKey).prop("checked", true);
    } else {
        return false;
    }
}



function contructVal(keyFilter, valFilter) {

    return valFilter.join('|');


    /* var paramInUri = getParameterByName(keyFilter, uriForRedirect);

     if (paramInUri != null) {
     if (paramInUri.indexOf('|' + valFilter) == false || paramInUri.indexOf(valFilter + '|') == false)
     return paramInUri;
     else
     return paramInUri + '|' + valFilter;
     } else {
     return valFilter;
     }
     */

}

$("[name^='btnfilter_']").click(function (event) {
    event.preventDefault();
    submitFilters();
});


var uriForRedirect = window.location.href;

function submitFilters() {

    for (domain in actualFilters) {
        valFilter = contructVal(domain, actualFilters[domain]);
        if (actualFilters[domain].length == 0) {
            uriForRedirect = RemoveParameterFromUrl(uriForRedirect, domain);
        } else {
            uriForRedirect = updateQueryStringParameter(uriForRedirect, domain, valFilter);
        }
    }
    uriForRedirect = RemoveParameterFromUrl(uriForRedirect, 'page');
    window.location.href = uriForRedirect;
}

function RemoveParameterFromUrl(url, parameter) {
    return url
        .replace(new RegExp('[?&]' + parameter + '=[^&#]*(#.*)?$'), '$1')
        .replace(new RegExp('([?&])' + parameter + '=[^&]*&'), '$1');
}


function constructFilterItem(id, val, text) {
    var template1 = '<li id="';
    var template2 = '" title="';
    var template3 = '"> <span class="croix_filtres" role="presentation" onclick="removeFilter($(this).parent().attr(\'id\'))">×</span>';
    var template4 = '</li>';

    var generatedId = id + "°°" + val;

    if (!$('#' + generatedId).exists() && val != '' && text != false) {

        $('#filterAbstract').append(template1 + generatedId + template2 + val + template3 + text + template4);
    }

}

// FILTRES FONCTION
function filtre(selectFilter, idCurrent, type)
{

    currentSlug = idCurrent;
    currentType = type;

    var values = [];


    $('#' + selectFilter.attr('id') + ' :selected').each(function (i, selected) {
        if ($(selected).val() != '') {

            constructFilterItem(selectFilter.attr('id'), $(selected).val(), $(selected).text());
            $('#' + selectFilter.attr('id')).val('').trigger('change');
        }
    });


    actualFilters[selectFilter.attr('id')] = values;

}

//PAGINATION FONCTION
function pagination(classAttribut, e, idCurrent, type, libelle)
{
    e.preventDefault();
    redirectSortFilterPage(null, null, classAttribut, type, libelle);

}

//# sourceMappingURL=filtreTri.js.map

